import { withRegisterSubmit } from '@psyomics/ui-common';
import { Checkboxes, PageLayout, RegisterForm } from '@psyomics/ui-components';
import { type ComponentProps, useCallback } from 'react';

import { CRISIS_ACKNOWLEDGED_KEY } from '../../app/crisis-acknowledgement';
import { PATIENT_REDIRECT_WHITELIST } from '../../app/redirect-whitelists';
import { getConfig } from '../../config';
import { usePatientAppBarContext } from '../../shared/contexts/patient-app-bar';

const RegisterWithSubmit = withRegisterSubmit(RegisterForm, {
  defaultMethod: 'phone',
  localStorageData: { [CRISIS_ACKNOWLEDGED_KEY]: 'true' },
  passwordLess: true,
  redirectWhitelist: PATIENT_REDIRECT_WHITELIST,
});

const SelfReferralRegister = ({ redirect }: { readonly redirect: string }) => {
  const { setShowUrgentHelp } = usePatientAppBarContext();
  const { patientApiUrl } = getConfig();
  const renderCheckboxes = useCallback(
    ({
      control,
      errors,
    }: {
      readonly control: ComponentProps<typeof Checkboxes>['control'];
      readonly errors: ComponentProps<typeof Checkboxes>['errors'];
    }) => <Checkboxes control={control} errors={errors} onUrgentHelpClick={() => setShowUrgentHelp(true)} />,
    [setShowUrgentHelp]
  );

  return (
    <PageLayout width="narrow">
      <RegisterWithSubmit
        apiUrl={patientApiUrl}
        headerKey="auth.register.passwordLess.header"
        redirect={redirect}
        renderCheckboxes={renderCheckboxes}
        showRegistrationMethodToggle={true}
        subHeaderKey="auth.register.passwordLess.subHeader"
        submitButtonKey="auth.register.startSurveyButtonText"
        switchToEmailLabelKey="auth.register.passwordLess.switchToEmailUsernameLabel"
        switchToMobileLabelKey="auth.register.passwordLess.switchToMobileUsernameLabel"
      />
    </PageLayout>
  );
};

export { SelfReferralRegister };
